import { render, staticRenderFns } from "./contract-orderbook.vue?vue&type=template&id=647cf351&"
import script from "./contract-orderbook.vue?vue&type=script&lang=js&"
export * from "./contract-orderbook.vue?vue&type=script&lang=js&"
import style0 from "./contract-orderbook.vue?vue&type=style&index=0&id=647cf351&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports